import { db } from "../../Environment/firebase";
import { collection,where,getDocs,query,DocumentData } from "firebase/firestore";


export type UserDataType = {
    uid:string,
    loginDates:string,
    displayName:string,
    email: string,
    userStatus: string
}

export const getUserData = async(userCategory:string)=>{

    const datalist:UserDataType[] = []
    const databaseRef = collection(db, "users");
    const querySnapshot = await getDocs(query(databaseRef,where('userStatus','==',userCategory)));

    querySnapshot.forEach((doc) => {
        const content: DocumentData = doc.data();
        
        let loginDate:string='';
        if (typeof doc.data().changeTime === 'undefined') {
            const loginDateBase = new Date(doc.data().createTime.seconds * 1000 + doc.data().createTime.nanoseconds / 1000);
            loginDate = `${loginDateBase.getFullYear()}/${loginDateBase.getMonth()+1}/${loginDateBase.getDate()}`;

        } else {
            const loginDateBase = new Date(doc.data().changeTime.seconds * 1000 + doc.data().changeTime.nanoseconds / 1000);
            loginDate = `${loginDateBase.getFullYear()}/${loginDateBase.getMonth()+1}/${loginDateBase.getDate()}`  
        }
        datalist.push(
            {
                uid: content.uid || '',
                displayName: content.displayName || '',
                email: content.email || '',
                userStatus: content.userStatus || '',
                loginDates:loginDate,
            }
        ) 
    })
    return datalist
}

export const getUserDataFromAddress = async(mailAddress:string)=>{

    const datalist:UserDataType[] = []
    const databaseRef = collection(db, "users");
    const querySnapshot = await getDocs(query(databaseRef,where('email','==',mailAddress)));

    querySnapshot.forEach((doc) => {
        const content: DocumentData = doc.data();
        
        let loginDate:string='';
        if (typeof doc.data().changeTime === 'undefined') {
            const loginDateBase = new Date(doc.data().createTime.seconds * 1000 + doc.data().createTime.nanoseconds / 1000);
            loginDate = `${loginDateBase.getFullYear()}/${loginDateBase.getMonth()}/${loginDateBase.getDate()}`;

        } else {
            const loginDateBase = new Date(doc.data().changeTime.seconds * 1000 + doc.data().changeTime.nanoseconds / 1000);
            loginDate = `${loginDateBase.getFullYear()}/${loginDateBase.getMonth()}/${loginDateBase.getDate()}`  
        }
        datalist.push(
            {
                uid: content.uid || '',
                displayName: content.displayName || '',
                email: content.email || '',
                userStatus: content.userStatus || '',
                loginDates:loginDate,
            }
        ) 
    })
    return datalist
}